/* eslint-disable react/no-multi-comp */
import React from 'react';
import ContentLoader from 'react-content-loader';
import { Box } from 'rebass/styled-components';
import { useTheme } from 'styled-components';

export const ContactDetailSkeleton = () => {
  const { colors } = useTheme();

  return (
    <ContentLoader
      speed={2}
      width={600}
      height={500}
      viewBox="0 0 600 500"
      backgroundColor={colors.neutral[50]}
      foregroundColor={colors.neutral[20]}
    >
      <Box as="rect" x="0" y="16" rx="8" ry="8" width="80" height="16" />
      <Box as="rect" x="104" y="16" rx="8" ry="8" width="80" height="16" />
      <Box as="rect" x="200" y="16" rx="8" ry="8" width="80" height="16" />

      {/* experience 1 */}
      <rect x="0" y="67" rx="3" ry="3" width="32" height="32" />
      <rect x="42" y="70" rx="3" ry="3" width="160" height="8" />
      <rect x="42" y="86" rx="3" ry="3" width="120" height="8" />
      <rect x="42" y="102" rx="3" ry="3" width="80" height="8" />

      {/* experience 2 */}
      <rect x="0" y="159" rx="3" ry="3" width="32" height="32" />
      <rect x="42" y="162" rx="3" ry="3" width="160" height="8" />
      <rect x="42" y="178" rx="3" ry="3" width="120" height="8" />
      <rect x="42" y="194" rx="3" ry="3" width="80" height="8" />

      {/* experience 3 */}
      <rect x="0" y="251" rx="3" ry="3" width="32" height="32" />
      <rect x="42" y="254" rx="3" ry="3" width="160" height="8" />
      <rect x="42" y="270" rx="3" ry="3" width="120" height="8" />
      <rect x="42" y="286" rx="3" ry="3" width="80" height="8" />
    </ContentLoader>
  );
};

export const ContactDetailSideSkeleton = () => {
  const { colors } = useTheme();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={360}
      viewBox="0 0 320 360"
      backgroundColor={colors.neutral[50]}
      foregroundColor={colors.neutral[20]}
    >
      <circle cx="279" cy="40" r="24" />
      <rect x="16" y="20" rx="8" ry="8" width="160" height="12" />
      <rect x="16" y="44" rx="8" ry="8" width="120" height="12" />
      <rect x="16" y="68" rx="8" ry="8" width="80" height="12" />
    </ContentLoader>
  );
};
